import { mdiClipboardText, mdiCardAccountPhone, mdiMarkerCheck, mdiApps, mdiClockOutline, mdiCalendar, mdiAlarmPlus, mdiSchool, mdiAccountMultiple, mdiEmoticonOutline, mdiClipboardAccount, mdiPuzzleEdit, mdiFolderInformationOutline } from '@mdi/js'
import Axios from 'axios'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'
import i18n from '@/i18n'
import config from '@/config/config.js'

// const hrUrl = 'https://hr.g2e.gov.mo'
const hrUrl = 'https://g2e.informac.gov.mo'
const hrToPtUrl = hrUrl + '/MainPage/Index/language/pt_PT/'
// const g2eUrl = 'https://g2e.gov.mo'
const g2eUrl = ''

function getHrSiteParams () {
  let oauthAccType = parseJwt(getStorage('g2e-jwt-token')).oauth_acc_type === 'conta_unica' ? 'govmo_account' : 'govmo_entity_account'
  return '?fromUrl=g2e.gov.mo&auth_provider_id=' + oauthAccType
}

const iconMap = []
iconMap['md md-assignment'] = mdiClipboardText
iconMap['md md-quick-contacts-dialer'] = mdiCardAccountPhone
iconMap['md md-beenhere'] = mdiMarkerCheck
iconMap['md md-apps'] = mdiApps
iconMap['md md-schedule'] = mdiClockOutline
iconMap['md md-event'] = mdiCalendar
iconMap['md md-alarm-add'] = mdiAlarmPlus
iconMap['md md-school'] = mdiSchool
iconMap['md md-people'] = mdiAccountMultiple
iconMap['md md-tag-faces'] = mdiEmoticonOutline
iconMap['md md-assignment-ind '] = mdiClipboardAccount
iconMap['md md-extension'] = mdiPuzzleEdit
iconMap['md md-info-outline'] = mdiFolderInformationOutline

export default {

  getG2ePortalSignInUrl () {
    let url = getStorage('g2e-log-in-url')
    if (!url) {
      url = config.domain
      // url = 'https://g2e.gov.mo/zh-hant/sign-in-account-types/'
    }
    return url
  },

  getG2ePortalSignOutUrl () {
    let url = getStorage('g2e-log-out-url')
    // url = decodeURIComponent(url).replace(/&amp;/g, '&')
    // let url = 'https://g2e.gov.mo/zh-hant/sign-in-account-types/'
    return url
  },

  getG2ePortalAppsListUrl () {
    if (i18n.locale === 'zh') {
      return g2eUrl + '/zh-hant/apps-list/'
    } else {
      return g2eUrl + '/pt/lista-de-aplicacoes/'
    }
  },

  getHrUrl () {
    if (i18n.locale === 'zh') {
      return hrUrl
    } else {
      return hrToPtUrl + hrUrl
    }
  },

  getHrOTUrl () {
    return this.getHrUrl() + '/Attendance/StaffDraftOT/indexg2e' + getHrSiteParams()
  },

  getHrAttendanceUrl () {
    return this.getHrUrl() + '/Attendance/View/indexg2e' + getHrSiteParams()
  },

  getHrAttendanceAbjUrl () {
    return this.getHrUrl() + '/Attendance/View/amend' + getHrSiteParams()
  },

  hrOtEditUrl () {
    return this.getHrUrl() + '/Attendance/StaffDraftOT/amend' + getHrSiteParams()
  },

  hrOtProposalUrl () {
    return this.getHrUrl() + '/Proposal/OTProposal/apply' + getHrSiteParams()
  },

  getHrMapaUrl () {
    return this.getHrUrl() + '/PublicServant/Me/mapaIndexg2e' + getHrSiteParams()
  },

  getHrTrainingUrl () {
    return this.getHrUrl() + '/PublicServant/Me/trainingIndexg2e' + getHrSiteParams()
  },

  getHrPaperLeaveUrl () {
    return this.getHrUrl() + '/eLeave/StaffPaperApplication/apply' + getHrSiteParams()
  },

  // hrOtDownloadUrl () {
  //   return hrUrl + '/Attendance/StaffDraftOT/downloadOTForm/'
  // },

  // return menuList array
  // array object
  // {
  //   title: 'title',
  //   href: 'href',
  //   icon: 'icon',
  //   counterId: 'total',
  //   subList: [{
  //     title: 'title',
  //     href: 'href',
  //     counterId: 'OFC'
  //   }]
  // }
  getG2eMenu (lang) {
    return new Promise((resolve, reject) => {
      let url = null
      if (lang === 'zh') {
        url = g2eUrl + '/zh-hant/menubar/'
      } else {
        url = g2eUrl + '/pt/menubar/'
      }
      Axios.get(url).then(
        response => {
          let dom = new DOMParser().parseFromString(response.data, 'text/html')

          let menuList = []
          dom.querySelectorAll('#main-menu > li').forEach((element, index) => {
            menuList[index] = {}
            menuList[index]['title'] = element.querySelector('.title').textContent
            menuList[index]['href'] = element.querySelector('a').getAttribute('href')
            if (menuList[index]['href'] === '#') menuList[index]['href'] = null
            let tIcon = element.querySelector('.gui-icon i.md').className
            menuList[index]['icon'] = iconMap[tIcon]
            let badgeEle = element.querySelector('.badge')
            if (badgeEle) {
              menuList[index]['counterId'] = badgeEle.dataset.counterId
            }

            // sub list
            menuList[index]['subList'] = []
            element.querySelectorAll('ul > li').forEach((subElement, subIndex) => {
              menuList[index]['subList'][subIndex] = {}
              menuList[index]['subList'][subIndex]['title'] = subElement.querySelector('.title').textContent
              menuList[index]['subList'][subIndex]['href'] = subElement.querySelector('a').getAttribute('href')
              if (menuList[index]['subList'][subIndex]['href'] === '#') menuList[index]['subList'][subIndex]['href'] = null
              let badgeEle = subElement.querySelector('.badge')
              if (badgeEle) {
                menuList[index]['subList'][subIndex]['counterId'] = badgeEle.dataset.counterId
              }
            })
          })

          resolve(menuList)
        },
        error => {
          console.error(error)
          reject(error)
        }
      )
    })
  },

  // return iconGrid array
  // array object
  // {
  //   title: 'title',
  //   href: 'href',
  //   iconClass: 'iconClass',
  // }
  getG2eIconGrid (lang, cb) {
    let url = null
    if (lang === 'zh') {
      url = g2eUrl + '/zh-hant/auto-draft/'
    } else {
      url = g2eUrl + '/pt/auto-draft/'
    }
    Axios.get(url).then(
      response => {
        let dom = new DOMParser().parseFromString(response.data, 'text/html')
        let iconGridList = []
        dom.querySelectorAll('.app-list > li').forEach((element, index) => {
          iconGridList[index] = {}
          iconGridList[index]['title'] = element.querySelector('.app-list--item-content-title').textContent.trim()
          iconGridList[index]['href'] = element.querySelector('a').getAttribute('href').trim()
          iconGridList[index]['iconClass'] = element.querySelector('.app-list--item-icon i').className
        })

        cb(iconGridList)
      },
      error => {
        console.error(error)
      }
    )
  }
}
